import React from 'react';
import {Row, Col} from 'antd';
import {hashHistory} from 'react-router';
import {TableView} from '../../components';
import moment from 'moment';
import '../print/table.css';

class ShipRequestPrintBatchSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mapRows: [],
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || ''
        };
        this.pageChange = this.pageChange.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    goBack() {
        hashHistory.goBack();
    }

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, () => {
            this.initData();
        });
    }

    split_array(arr, len) {
        var a_len = arr.length;
        var result = [];
        for (var i = 0; i < a_len; i += len) {
            result.push(arr.slice(i, i + len));
        }
        return result;
    }

    initData() {
        const data = JSON.parse(window.sessionStorage.getItem('shipRequestBatchSummary') || '[]');
        const linkAddress = window.sessionStorage.getItem('shipRequestBatchAddress');

        const groupedMap = {};
        data.forEach(item => {
            const key = `${item.itemNum || ''}__${item.itemDesc || ''}`;
            if (!groupedMap[key]) {
                groupedMap[key] = {
                    id: key,
                    itemNum: item.itemNum,
                    itemDesc: item.itemDesc,
                    quantity: 0
                };
            }
            groupedMap[key].quantity += Number(item.quantity) || 0;
        });

        const aggregatedData = Object.values(groupedMap)
            .sort((a, b) => (a.itemNum || '').localeCompare(b.itemNum || ''));

        const totalcount = aggregatedData.reduce((sum, row) => sum + row.quantity, 0);
        const result = this.split_array(aggregatedData, 9999);
        const mapRows = [];

        for (let j = 0; j < result.length; j++) {
            let pageTotal = 0;
            for (let z = 0; z < result[j].length; z++) {
                pageTotal += result[j][z].quantity;
            }
            result[j].push({
                id: `summary-total-${j}`,
                isSummaryRow: true,
                itemNum: '合计:',
                quantity: result.length === 1 ? totalcount : pageTotal
            });

            mapRows[j] = {
                list: result[j],
                key: j,
                receiptCust: data.length > 0 ? data[0].receiptCust : '',
                salesUnitName: data.length > 0 ? data[0].salesUnitName : '',
                printBatchId: data.length > 0 ? data[0].printBatchId : '',
                printDate: data.length > 0 ? data[0].printDate : ''
            };
        }

        this.setState({
            mapRows,
            linkAddress
        });
    }

    componentDidMount() {
        this.initData();
    }

    render() {
        const {mapRows, userData, linkAddress, total, searchObj} = this.state;
        const tableViewProps = {
            loading: false,
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,
                pageSize: searchObj.s,
                onChange: this.pageChange
            },
            paginationHide: true,
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: '20%',
                    render: (text, record) => {
                        if (record.isSummaryRow) {
                            return (<span style={{fontWeight: 'bold'}}>{text}</span>);
                        }
                        return (<span>{text}</span>);
                    }
                },
                {
                    title: '物料名称',
                    dataIndex: 'itemDesc',
                    width: '60%',
                    render: (text, record) => {
                        if (record.isSummaryRow) {
                            return (<span style={{fontWeight: 'bold'}}>{text}</span>);
                        }
                        return (<span>{text}</span>);
                    }
                },
                {
                    title: '数量',
                    dataIndex: 'quantity',
                    width: '20%',
                    render: (text, record) => {
                        if (record.isSummaryRow) {
                            return (<span style={{fontWeight: 'bold'}}>{text}</span>);
                        }
                        return (<span>{text}</span>);
                    }
                }
            ]
        };
        const h1 = {width: '100%', textAlign: 'center', color: '#000', marginTop: 15, fontSize: '20px'};
        const h2 = {width: '100%', textAlign: 'center', color: '#000', marginTop: 0, fontSize: '18px'};
        const top = {width: '100%', textAlign: 'center', position: 'relative', color: '#000'};
        const printDate = moment(new Date()).format('YYYY/MM/DD');
        const dom = (mapRows || []).map(function (ele) {
            return <div style={{padding: '5px', color: '#000'}} key={ele.key}>
                <p style={top}>
                    <span style={{
                        position: 'absolute',
                        left: 0,
                        color: '#000'
                    }}>送货批次：{ele.printBatchId}</span>
                </p>
                <p style={top}>
                    <span style={{
                        position: 'absolute',
                        right: 0,
                        color: '#000'
                    }}>打印时间：{printDate}</span>
                </p>
                <p style={h1}>浙江天正电气股份有限公司</p>
                <p style={h2}>送货单</p>
                <div className="dms-table-box" style={{lineHeight: '5px', marginTop: 0}}>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={20}>
                            <label>送货日期：{ele.printDate ? moment(ele.printDate).format('YYYY-MM-DD HH:mm:ss') : ''}</label>
                        </Col>
                    </Row>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={20}>
                            <label>客户名称：{ele.salesUnitName}</label>
                        </Col>
                    </Row>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={20}>
                            <label>地址电话：{ele.receiptCust}</label>
                        </Col>
                    </Row>
                    <div style={{display: "block"}}>
                        <div className="dms-table-box yourClass">
                            <TableView {...tableViewProps} rows={ele.list}/>
                        </div>
                    </div>
                </div>
                <div style={{display: "block"}}>
                    <p><span>操作员：{userData.userName}</span>&emsp;<span>出库：____________</span>&emsp;
                        <span>客户签名：____________</span>
                    </p>
                    <p><span>联系方式：{linkAddress}</span>
                    </p>
                </div>
                <div style={{pageBreakAfter: 'always'}}></div>
            </div>;
        });
        return (
            <div>
                {dom}
            </div>
        );
    }
}

export default ShipRequestPrintBatchSummary;



// WEBPACK FOOTER //
// ./src/routes/shipRequest/shipRequestPrintBatchSummary.js